<section class="mat-typography">
    <app-runbox-section size="h2">
        <div runbox-section-header class="section-header-with-toggle">
            <h1 class="runbox-section-header">App Passwords</h1>
            <mat-slide-toggle [(ngModel)]="rmm.account_security.tfa.settings.is_app_pass_enabled"
                (ngModelChange)="app_pass_toggle_main_switch()">
                {{ rmm.account_security.tfa.settings.is_app_pass_enabled ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
        </div>
        <div runbox-section-content class="runbox-section-content">
            <p>Here you can create App Passwords for specific applications or devices. App Passwords are strong
                passwords
                that replace your account password for each service.</p>
            <p>The main advantage of using app specific passwords is that you can use different passwords on each app or
                device. If you happen to lose a device you can immediately disable the password used by that device.</p>
            <p>App Passwords work for all non-web services such as IMAP, POP, SMTP, FTP, CalDAV, and CardDAV. For
                example,
                create one password for 'Outlook on my MacBook Pro', and another password for 'My Android email client'.
            </p>
            <p>For more information on these settings, please see <a
                    href="https://help.runbox.com/account-security/#App_Passwords" target="help">App Passwords Help</a>.
            </p>

            <table mat-table style="width: 100%" *ngIf="rmm.account_security.app_pass.results"
                [dataSource]="rmm.account_security.app_pass.results" multiTemplateDataRows>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let app_pass"> {{ app_pass.name }} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef
                        [ngStyle]="{ 'text-align': mobileQuery.matches ? 'end' : null }">
                        Status
                    </th>
                    <td mat-cell *matCellDef="let app_pass"
                        [ngStyle]="{ 'text-align': mobileQuery.matches ? 'end' : null }">
                        <mat-slide-toggle [(ngModel)]="app_pass.is_enabled" (ngModelChange)="app_pass_toggle(app_pass)">
                            {{ app_pass.is_enabled ? 'Enabled' : 'Disabled' }}
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <ng-container matColumnDef="password">
                    <th mat-header-cell *matHeaderCellDef> Password </th>
                    <td mat-cell *matCellDef="let app_pass">
                        <span
                            *ngIf="rmm.account_security.app_pass.password[app_pass.name] as password; else hiddenPassword"
                            style="font-family: monospace">
                            <strong> {{ password }} </strong>
                        </span>
                    </td>
                </ng-container>

                <ng-template #hiddenPassword>
                    <span style="font-family: monospace"> **************** </span>
                </ng-template>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let app_pass">
                        <button mat-raised-button class="primaryContentButton" type='button'
                            (click)="app_pass_delete(app_pass)"
                            [disabled]="rmm.account_security.app_pass.is_busy">Delete</button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="details-row">
                    <td mat-cell *matCellDef="let app_pass" [attr.colspan]="app_pass_columns_mobile.length">
                        <div
                            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                            <div>
                                <span
                                    *ngIf="rmm.account_security.app_pass.password[app_pass.name] as password; else hiddenPassword"
                                style="font-family: monospace">
                                    <strong> {{ password }} </strong>
                                </span>
                            </div>
                            <div>
                                <button mat-raised-button class="primaryContentButton" type='button'
                                    (click)="app_pass_delete(app_pass)"
                                    [disabled]="rmm.account_security.app_pass.is_busy">Delete</button>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row
                    *matHeaderRowDef="mobileQuery.matches ? app_pass_columns_mobile : app_pass_columns_desktop"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: mobileQuery.matches ? app_pass_columns_mobile : app_pass_columns_desktop;"
                    [ngClass]="{ 'regularRow': mobileQuery.matches }"></tr>
                <tr mat-row *matRowDef="let row; columns: ['details-row']" class="detailsRow"
                    [ngStyle]="{ 'display': mobileQuery.matches ? null : 'none' }"></tr>
            </table>
        </div>
    </app-runbox-section>
    <app-runbox-section>
        <div runbox-section-header>
            <h2 class="runbox-section-header">New App Password</h2>
        </div>
        <div runbox-section-content class="runbox-section-content">
            <div style="display: flex; flex-wrap: wrap; align-items: center;">
                <p style="margin-bottom: 0px;">
                    <strong>App Password Name:</strong>
                    <mat-form-field>
                        <input matInput name="app_pass_name" placeholder="Enter App/Device" maxlength="64"
                            [(ngModel)]="app_pass_name" (ngModelChange)="app_pass_name_changed()">
                    </mat-form-field>
                </p>
                <div style="display: flex; flex-wrap: wrap-reverse; align-items: center; gap: 20px;">
                    <button mat-raised-button class="primaryContentButton"
                        [disabled]="is_btn_app_pass_new_disabled || rmm.account_security.app_pass.is_busy"
                        (click)="app_pass_create()">Submit</button>
                    <div>Use a name so you will know which device you are using this App Password on.</div>
                </div>
            </div>
        </div>
    </app-runbox-section>
</section>
